const NinLogTypes = {
  FETCH_NIN_LOG_START: 'FETCH_NIN_LOG_START',
  FETCH_NIN_LOG_SUCCESS: 'FETCH_NIN_LOG_SUCCESS',
  FETCH_NIN_LOG_FAILURE: 'FETCH_NIN_LOG_FAILURE',
};

export default NinLogTypes;
